import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CommonTable from "../../common-components/common-tables/CommonTable";
import { fetchHygieneCommandCenterMatrixData } from "../../../redux/hygiene-reducers/hygieneSlice";
import { ReloadIcon } from "../../../images/icons/icons";

const TaskCompletionMatrix = ({ userInfoData, prevFilters, setModValues }) => {
  const dispatch = useDispatch();
  const {
    hygieneCommandCenterMatrix,
    hygieneCommandCenterMatrixLoading,
    hygieneCommandCenterMatrixError,
  } = useSelector((state) => state.hygiene);

  const [pageLimit, setPageLimit] = useState(10);
  const [isPage, setIsPage] = useState(0);
  const iniFilters = {
    ...prevFilters,
    // limit: 100,
    // page: 1,
    limit: pageLimit || 10,
    page: isPage + 1,
  };
  const [filters, setFilters] = useState(iniFilters);

  const iniTbDatas = {
    allDatas: [],
    pagination: [],
    gyms: [],
  };
  const [TbData, setTbData] = useState(iniTbDatas);

  const getStatusBadge = (status) => {
    const statusConfig = {
      COMPLETED: {
        label: "Completed",
        className: "tb-data tb-badge tb-badge-success",
      },
      PENDING: {
        label: "Pending",
        className: "tb-data tb-badge tb-badge-success-2",
      },
      MISSED: { label: "Missed", className: "tb-data tb-badge not-assigned" },
    };
    return (
      statusConfig[status] || { label: status, className: "tb-data tb-badge" }
    );
  };

  const allGyms = TbData.gyms || [];

  function getCommandCenterMatrix() {
    dispatch(
      fetchHygieneCommandCenterMatrixData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getCommandCenterMatrix();
  }, [filters]);

  useEffect(() => {
    if (
      !hygieneCommandCenterMatrixLoading &&
      !hygieneCommandCenterMatrixError &&
      hygieneCommandCenterMatrix?.status &&
      hygieneCommandCenterMatrix?.data?.length > 0
    ) {
      setTbData((prevs) => ({
        ...prevs,
        allDatas: hygieneCommandCenterMatrix.data,
        pagination: hygieneCommandCenterMatrix?.pagination || [],
        gyms: hygieneCommandCenterMatrix?.gyms || [],
      }));
    } else {
      setTbData(iniTbDatas);
    }
  }, [
    hygieneCommandCenterMatrixLoading,
    hygieneCommandCenterMatrixError,
    hygieneCommandCenterMatrix,
  ]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      ...prevFilters,
      limit: pageLimit || 10,
      page: isPage + 1,
    }));
  }, [pageLimit, isPage, prevFilters]);

  const tbColumns = [
    {
      dataField: "task_name",
      text: "Task Name",
      formatter: (_, row) => {
        const taskName = row?.task_name || "NA";
        const isLong = taskName.length > 50;

        return (
          <div className="tb-flex-col">
            <span
              className={`tb-data tb-link ${isLong ? "tb-data-long" : ""}`}
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "task_details",
                  rowData: row,
                }))
              }
            >
              {taskName}
            </span>
            <span className="tb-data hcc-task-frequency">
              {row.frequency_type}
            </span>
          </div>
        );
      },
    },
    ...allGyms.map((gym) => ({
      dataField: `gym_${gym.gym_id}`,
      text: gym.gym_name,
      // wrapHeader: true,
      formatter: (_, row) => {
        const gymStatus = row.gyms?.find((g) => g.gym_id === gym.gym_id);
        const statusInfo = gymStatus?.status
          ? getStatusBadge(gymStatus.status?.toUpperCase())
          : "tb-data";

        return (
          <div className="tb-flex">
            <span
              className={`${statusInfo.className} cursor-pointer`}
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "task_details",
                  rowData: { ...row, ...gymStatus },
                }))
              }
            >
              {statusInfo?.label || "NA"}
            </span>
          </div>
        );
      },
    })),
  ];

  return (
    <>
      <div className="hcc-matrix-section mt30">
        <div className="hcc-section-header">
          <div className="hcc-section-title-container">
            <div>
              <h2 className="hcc-section-title">
                Critical Tasks Across All Gyms
              </h2>

              <p className="hcc-section-subtitle">
                Real-time task completion status for all locations
              </p>
            </div>

            <button
              type="button"
              className="hcc-reload-button"
              onClick={() => getCommandCenterMatrix()}
              title="Reload"
            >
              <ReloadIcon />
            </button>
          </div>

          <div className="hcc-legend">
            <div className="hcc-legend-item">
              <span className="hcc-legend-dot hcc-legend-dot-completed"></span>
              <span className="hcc-legend-label">COMPLETED</span>
            </div>
            <div className="hcc-legend-item">
              <span className="hcc-legend-dot hcc-legend-dot-pending"></span>
              <span className="hcc-legend-label">PENDING</span>
            </div>
            <div className="hcc-legend-item">
              <span className="hcc-legend-dot hcc-legend-dot-missed"></span>
              <span className="hcc-legend-label">MISSED</span>
            </div>
          </div>
        </div>

        <div className="common-table-container mt15">
          <CommonTable
            tableData={TbData.allDatas}
            tableColumns={tbColumns}
            tablePagination={TbData.pagination}
            isPage={isPage}
            setIsPage={setIsPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            isLoading={hygieneCommandCenterMatrixLoading}
            isFirstColSticky={true}
          />
        </div>
      </div>
    </>
  );
};

export default TaskCompletionMatrix;
